var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessGreeninline = function SvgSuccessGreeninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2D822B",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2D822B",
    strokeLinecap: "square",
    d: "m6.85 10.875 2.36 1.875 4.14-5.5"
  })));
};
export default SvgSuccessGreeninline;